export default __webpack_public_path__ + "static/media/my-shopping.d5c849d6.svg";